import { Partner } from "@justhome/api-core";

export interface ParsedPartner extends Partner {
  id: string;
  themeCss: string;
}

/**
 * Adds the themeCss to a partner.
 * @param partner
 * @returns The parsed partner.
 */
const parsePartner = (partner: Partner): ParsedPartner => {
  return {
    ...partner,
    themeCss: themeJsonToCss(partner.theme),
  };
};

const themeJsonToCss = (theme: Record<string, string>) => {
  const colors = Object.keys(theme)
    .map((name) => {
      const rgb = hexToRgb(theme[name] || "");
      return rgb ? `--color-${name}: ${rgb.r} ${rgb.g} ${rgb.b};` : "";
    })
    .join("");
  return `body{${colors}}`;
};

const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1] || "", 16),
        g: parseInt(result[2] || "", 16),
        b: parseInt(result[3] || "", 16),
      }
    : null;
};

export default parsePartner;
